import { render, staticRenderFns } from "./ProjectSummary.vue?vue&type=template&id=6437cfc0&"
import script from "./ProjectSummary.vue?vue&type=script&lang=ts&"
export * from "./ProjectSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports